"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginNavNotificationReducer = void 0;
var _actionTypes = require("../actionTypes");
var initialState = false;
var marginNavNotificationReducer = exports.marginNavNotificationReducer = function marginNavNotificationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type;
  switch (type) {
    case _actionTypes.ADD_MARGIN_NOTIFICATION_ICON:
      return true;
    case _actionTypes.REMOVE_MARGIN_NOTIFICATION_ICON:
      return false;
    default:
      return state;
  }
};